export default "__VITE_ASSET__DUxYGQis__"